import { Badge } from "@/components/ui/badge";

const STYLES = {
    approved: ["Approved", "bg-emerald-50 text-emerald-700 border-emerald-200"],
    pending: ["Awaiting vendor", "bg-gold-500/10 text-gold-700 border-gold-200"],
    rejected: ["Rejected", "bg-red-50 text-red-700 border-red-200"],
};

/** Badge showing a deal's vendor-approval state (missing = approved). */
export default function VendorApprovalBadge({ status, testid }) {
    const [label, cls] = STYLES[status] || STYLES.approved;
    return (
        <Badge
            data-testid={testid}
            className={`${cls} border text-[10px] uppercase tracking-widest`}
        >
            {label}
        </Badge>
    );
}
